<div (click)="routingService.open('/main/precipitation-sample-points')"
     class="rounded-2 border-3 border-bottom background-pure-white p-3 pointer pointer-hover height-100px">
    @if (loading) {
        <lib-loading-placeholder [show]="loading"/>
    } @else {
        <div class=" d-flex justify-content-between">
            <div class=" fs-main fw-bold mb-3">Precipitation</div>
            <div class=" mt-auto mb-auto">
                <i class="color-primary-blue fa-solid fa-chevron-right fa-lg"></i>
            </div>
        </div>
        <div class="row">
            <div class="col col-auto">
        <span><app-precipitation-svg [height]="'30px'"
                                     [online]="true"
                                     [width]="'30px'"
                                     class="img-fluid img-max m-auto"></app-precipitation-svg></span>
                <span class="p-2">{{ fixedSamplePointStore.precipitationSamplePoints().length }}</span>
            </div>
        </div>
    }
</div>
